<script>
export default {
    props: {
        loading: {type: Boolean},
        fullPage: {type: Boolean}
    },
}
</script>

<template>
    <div class="loader-wrapper" v-if="loading" v-bind:class="{ 'full-page': this.fullPage }">
        <span class="v-loader"></span>
    </div>

</template>

<style scoped lang="scss">

@use 'bulma/sass/utilities/derived-variables' as *;

.loader-wrapper {
    width: 100%;

    &.full-page {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        padding: 0;

        .v-loader {
            position: absolute;
            top: calc(50% - 24px);
            left: calc(50% - 24px);
        }
    }

    &:not(.full-page) {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 50px;
    }
}

.v-loader {
    width: 48px;
    height: 48px;
    border: 3px solid $primary;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
}

.v-loader::after {
    content: '';
    box-sizing: border-box;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 3px solid;
    border-color: $link transparent;
}

@keyframes rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>
